import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  getToken,
} from "@/scripts/Common";

import {
  UpdateOrCreateConfiguredWebcharge,
  WebchargeSearchFilter,
} from "@/components/issuers/scripts/configuredWebcharges/types";

import {
  DataTableOptions,
} from "@/composables";

import {
  Ref,
} from "vue";

const fetchConfiguredWebcharges = async (issuerId: number, options: Ref<DataTableOptions>, queryParams: WebchargeSearchFilter) => {
  options.value.loading = true;

  const {
    error,
    response,
    paginationCount,
    totalItemCount
  } = await defaultFetch({
    apiName: 'getConfiguredWebchargesByIssuerId',
    bearer: getToken(),
    options: {
      method: httpMethod.GET,
      query: {
        issuerId,
        pageNumber: (options.value.pagination.page - 1).toString(),
        pageSize: options.value.pagination.itemsPerPage,
        sortColumn: options.value.sorting.sortBy,
        sortDirection: options.value.sorting.sortDesc ? 'desc' : 'asc',
        ...queryParams
      }
    },
  });

  options.value.loading = false;
  options.value.pagination.pageCount = paginationCount ?? 0;
  options.value.pagination.totalItemCount = totalItemCount ?? 0;

  return {
    error,
    paginationCount,
    totalItemCount,
    response
  }
}

const createOrUpdateConfiguredWebchargeList = async (method: httpMethod, webcharges: UpdateOrCreateConfiguredWebcharge[]) => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'configuredWebchargeResource',
    bearer: getToken(),
    options: {
      method
    },
    body: JSON.stringify({
      configuredWebchargesList: webcharges
    }),
  });

  return {
    error,
    response
  }
}

const deleteConfiguredWebcharges = async (webchargeIds: number[]) => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'deleteIssuerWebcharges',
    bearer: getToken(),
    options: {
      method: httpMethod.POST
    },
    body: JSON.stringify({
      webchargeIdList: webchargeIds
    }),
  });

  return {
    error,
    response
  }
}

const repeatWebcharge = async (protocolId: number) => {
  const {
    response,
    error,
  } = await defaultFetch({
    apiName: 'repeatLastWebcharge',
    bearer: getToken(),
    options: {
      method: httpMethod.PUT,
      routeParams: {
        protocolId: protocolId.toString(10)
      }
    }
  });

  return {
    response,
    error
  }
}

export {
  createOrUpdateConfiguredWebchargeList,
  fetchConfiguredWebcharges,
  deleteConfiguredWebcharges,
  repeatWebcharge
}
